import { render, staticRenderFns } from "./commonDocsMX.vue?vue&type=template&id=13e031c9"
import script from "./commonDocsMX.vue?vue&type=script&lang=js"
export * from "./commonDocsMX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports